import BaseService from "src/packages/BaseService";

export default class GameService extends BaseService {
	static get className () {
		return "game";
	}

	static async duplicate (id, form) {
		const response = await BaseService.getService().post("game/duplicate/" + id, form);
		return response.data;
	}
};
